import type { KeyBindingMap, KeyBindingOptions } from '@/libs/tinykeys'
import { tinykeys } from '@/libs/tinykeys'
import { useEffect } from 'react'

const useTinykeys = (
	keyBindingMap: KeyBindingMap,
	target: Window | HTMLElement = window,
	options: KeyBindingOptions = {},
) => {
	useEffect(() => {
		const unsubscribe = tinykeys(target, keyBindingMap, options)

		return () => unsubscribe()
	}, [keyBindingMap, target, options])

	return
}

export { useTinykeys }
